// `lib/logger` が本番でエラーを送る先（#422）。
//
// **なぜ `lib/eventTracker` を直接 import しないか**: `eventTracker` は情報ログに
// `logger` を使っている。逆向きに import すると `logger → eventTracker → logger` の
// 循環参照になる。このモジュールはアプリ内の何も import しないので、どちらからも
// 安全に参照できる。送信先は `initializeEventTracker()` が `setErrorSink` で登録する。
export type ErrorReport = {
  tag: string
  error: Error
  // Error 以外の引数。呼び出し側は `logger(tag, { productName, planType }, new Error(...))`
  // の形で文脈オブジェクトを渡すので、**落とさずそのまま運ぶ**
  context: unknown[]
}

export type ErrorSink = (report: ErrorReport) => void

let sink: ErrorSink | null = null

export const setErrorSink = (next: ErrorSink | null): void => {
  sink = next
}

// テスト用。登録済みかどうかだけを見る
export const hasErrorSink = (): boolean => sink !== null

// **黙らないことが唯一の目的。**
// #412 / #414 / #417 / #420 の fail-open は「ログには残る」を根拠にしているので、
// 送信先が未登録でも、送信が失敗しても、**その事実をブラウザのコンソールには必ず出す**。
//
// **例外は絶対に外へ出さない。** logger の失敗で課金画面が落ちたら本末転倒（#422）。
export const reportError = (report: ErrorReport): void => {
  if (!sink) {
    console.error(
      "[logger] no error sink registered; the error below was not reported",
      report.tag,
      report.error,
      ...report.context,
    )

    return
  }

  try {
    sink(report)
  } catch (sinkError) {
    console.error(
      "[logger] failed to report an error",
      report.tag,
      report.error,
      sinkError,
    )
  }
}
